import React from 'react';
import { Dumbbell, Briefcase } from 'lucide-react';

const RoleSelectionScreen = ({ onSelect }) => {
    return (
        <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 animate-in fade-in slide-in-from-bottom-8 duration-500 relative overflow-hidden bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-neutral-900/20 via-black to-black">

            {/* Contenedor principal con z-index para estar encima del fondo */}
            <div className="relative z-10 flex flex-col items-center w-full max-w-md">
                <div className="text-center mb-10">
                    <h1 className="text-3xl font-black text-white mb-2 italic uppercase tracking-tight">BIENVENIDO</h1>
                    <p className="text-gray-400 font-medium">¿Cómo vas a usar Gym Tracker Pro?</p>
                </div>

                <div className="grid grid-cols-1 gap-4 w-full">
                    {/* Tarjeta Atleta */}
                    <button
                        type="button" onClick={() => onSelect('athlete')}
                        className="bg-neutral-900 border border-neutral-800 p-6 rounded-2xl hover:border-red-600 hover:bg-red-900/10 transition-all duration-300 group text-left relative overflow-hidden"
                    >
                        {/* Efecto de brillo sutil al hover */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                        <div className="bg-neutral-800 w-12 h-12 rounded-full flex items-center justify-center mb-4 group-hover:bg-red-600 group-hover:text-white transition-colors duration-300">
                            <Dumbbell size={24} className="text-gray-400 group-hover:text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-white mb-1 uppercase italic">Soy Atleta</h3>
                        <p className="text-sm text-gray-500 group-hover:text-gray-300 transition-colors">Quiero registrar mis entrenamientos y ver mi progreso.</p>
                    </button>

                    {/* Tarjeta Entrenador */}
                    <button
                        type="button" onClick={() => onSelect('trainer')}
                        className="bg-neutral-900 border border-neutral-800 p-6 rounded-2xl hover:border-blue-600 hover:bg-blue-900/10 transition-all duration-300 group text-left relative overflow-hidden"
                    >
                        {/* Efecto de brillo sutil al hover */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                        <div className="bg-neutral-800 w-12 h-12 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
                            <Briefcase size={24} className="text-gray-400 group-hover:text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-white mb-1 uppercase italic">Soy Entrenador</h3>
                        <p className="text-sm text-gray-500 group-hover:text-gray-300 transition-colors">Quiero gestionar rutinas para mis clientes.</p>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RoleSelectionScreen;